// extracted by mini-css-extract-plugin
module.exports = {"pinkSpacerBubbleConainer":"_3KdVf","pinkBubble":"_2y9dF","heading":"_134TI","getStartedButton":"_3kgV4"};